(
    function (skyward, $, undefined) {
        skyward.studentsectioncalculatecreditscontrols = skyward.studentsectioncalculatecreditscontrols || {};

        var init = function (selector) {
            // UseOverride on change
            var studentSectionCalculateCreditsControlsSelector = $(selector).find('#editStudentSectionCalcCredits');
            var studentSectionCreditsPointsBreakdownSelector = $(selector).find('#editStudentSectionGPACreditsPoints');
            var studentSectionRequiredForGradeSelector = $(selector).find('#editStudentSectionRequiredGradeBuckets');

            if (studentSectionCalculateCreditsControlsSelector.length > 0 || studentSectionCreditsPointsBreakdownSelector.length > 0
                || studentSectionRequiredForGradeSelector.length > 0)
            {
                var useOverrideCalculateSelector = $(selector).find('input[id*="UseOverride"]');

                $(function ()
                {

                    useOverrideCalculateSelector.each(function ()
                    {
                        var useOverrideValue = skyward.controls.getValue(this);
                        var body = $(this).parent('div').parent('div');
                        var textboxinputs = body.find('input[type=text]');
                        var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

                        if (textboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                textboxinputs.attr('readonly', false);
                            }
                            else {
                                textboxinputs.attr('readonly', true);
                            }
                        }

                        if (checkboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                checkboxinputs.attr('disabled', false);
                            }
                            else {
                                checkboxinputs.attr('disabled', true);
                            }
                        }
                    });
                });

                useOverrideCalculateSelector.on('change', useOverrideOnChange);
            }
        };

        var useOverrideOnChange = function () {
            // screen variables
            var useOverride = $(this);
            var useOverrideValue = skyward.controls.getValue(useOverride);
            var body = useOverride.parent('div').parent('div');
            var textboxinputs = body.find('input[type=text]');
            var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

            if (textboxinputs.length > 0) {
                if (useOverrideValue == true) {
                    textboxinputs.attr('readonly', false);
                }
                else {
                    textboxinputs.attr('readonly', true);
                }
            }

            if (checkboxinputs.length > 0) {
                if (useOverrideValue == true) {
                    checkboxinputs.attr('disabled', false);
                }
                else {
                    checkboxinputs.attr('disabled', true);
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);